export const MAX_MESSAGE_CHARACTERS_LIMIT = 200
export const DEFAULT_LIMIT = 20

export const LANGUAGES_CONSTANTS = {
  English: {
    languageId: 1,
    label: 'English',
    languageCode: 'en'
  },
  French: {
    languageId: 2,
    label: 'French',
    languageCode: 'fr'
  },
  German: {
    languageId: 3,
    label: 'German',
    languageCode: 'de'
  },
  Spanish: {
    languageId: 4,
    label: 'Spanish',
    languageCode: 'es'
  },
  Portuguese: {
    languageId: 5,
    label: 'Portuguese',
    languageCode: 'pt'
  },
  Russian: {
    languageId: 6,
    label: 'Russian',
    languageCode: 'ru'
  }
}

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'authToken'
export const LANGUAGE = 'operator_language'
export const OPERATOR_ID = 'operator_id'
export const ROLE = 'operator_role'

/* ==========================================================================
Operator Roles
========================================================================== */
export const OPERATOR_ROLES = {
  operator: 'OPERATOR',
  operatorUser: 'OPERATOR_USER'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER_TYPE = {
  SCALE: 'scale',
  PULSE: 'pulse'
}

/* ==========================================================================
  TOASTER / NOTIFICATION Types
========================================================================== */
export const TOASTER_TYPE = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = {
  // ----single routes------------
  home: '/',
  inActiveGame: '/inactive-game',

  // ----crash routes------------
  aztecManGame: '/aztecman-game',
  galaxyGrabGame: '/galaxy-grab',
  followTheArrowGame: '/follow-the-arrow-game',
  powerOfThorGame: '/power-of-thor',
  happyBirdGame: '/happy-bird-game',

  // ----slot routes------------
  PandaPunchSlotGame: '/panda-punch',
  witchcauldronSlotGame: '/witch-orb',
  vikingSwordSlotGame: '/viking-sword',
  roadOfAnubisSlotGame: '/road-of-anubis',
  wildMafiaSlotGame: '/wild-mafia',
  mayaBonanza: '/maya-bonanza',
  cosmicHeroes: '/cosmic-hero', //
  egyptRush: '/egypt-rush',
  dragonCurse: '/dragon-curse',
  cyberBox: '/cyber-box',
  powerShield: '/power-shield',
  gatesOfTitan: '/gates-of-titan',
  gateOfHeaven: '/gate-of-heaven',
  ghostGuest: '/ghost-guests',
  purpleCave: '/purple-cave',
  spaceWars: '/space-wars',
  pineappleParadise: '/pineapple-paradise',
  destroyMonster: '/destroy-monsters',
  aztecProtector: '/aztec-protectors',
  lopenSecret: '/lopen-secrets',
  punchOfHeroes: '/punch-of-heroes',
  diamondGun: '/diamond-gun',
  zodiacRush: '/zodiac-rush',
  jellyBoom: '/jelly-boom',
  sweetRush: '/sweet-rush',
  moneyRate: '/money-rate',
  upgrade2199: '/upgrade-2199',
  theNorthFisher: '/the-north-fisher',
  theMiner: '/the-miner',
  luckyFarmer: '/lucky-farmer',
  theHunter: '/the-hunter',
  dizzyZombies: '/dizzy-zombies',
  catHouse: '/cat-house',
  egyptRising: '/egypt-rising',
  fiestaParty: '/fiesta-party',
  kingdomFire: '/kingdom-fire',
  shiningRingRising: '/shining-ring-rising',
  olympusRising: '/olympus-rising',
  ottomanLegends: '/ottoman-legends',
  warGods: '/war-gods',
  dragonsVsGuardian: '/dragons-vs-guardian',
  streetBattle: '/street-battle',
  lostAtlantis: '/lost-atlantis',
  lastSamurai: '/last-samurai',
  zeroth: '/zeroth',
  ninjaParadise: '/ninja-paradise',
  wantedCowboy: '/wanted-cowboy',
  wantedDeadOrNinja: '/wanted-dead-or-ninja',
  gatesOfNinja: '/gates-of-ninja',
  dede1000x: '/dede-1000x',

  // magnum games
  vampiresLair: '/vampires-lair',
  gladiatorColessium: '/gladiator-colessium',
  splendidSuleyman: '/splendid-suleyman',
  nordicRaiders: '/nordic-raiders',
  jewelOfWizard: '/jewel-of-wizard',
  cosmicCrazies: '/cosmic-crazies',
  jellyBliss: '/jelly-bliss',
  drunkieMonkey: '/drunkie-monkey',
  cakeMaster: '/cake-master',
  wonderlandGrove: '/wonderland-grove',
  sirensBeauty: '/sirens-beauty',
  amazonSisters: '/amazon-sisters',
  seekAndCatch: '/seek-and-catch',
  feralQuest: '/feral-quest',
  banditHunter: '/bandit-hunter',
  goldenQuarry: '/golden-quarry',
  tosuncuksFarm: '/tosuncuks-farm',
  dynoDynasty: '/dyno-dynasty',
  shadowOfSabbah: '/shadow-of-sabbah',
  solarSpins: '/solar-spins',

  // ----Custom games------------
  plinkoGame: '/plinko',
  blackjackGame: '/blackjack',
  mineGame: '/mines',
  rouletteGame: '/roulette'

}

/* ==========================================================================
  Game Ids
========================================================================== */
export const DEFAULT_GAME_ID = {
  // crash game ID
  AZTECMAN: 105,
  FOLLOW_THE_ARROW: 106,
  GALAXY_GRAB: 107,
  POWER_OF_THOR: 108,
  HAPPY_BIRD: 5,

  // slot game ID
  MAYA_BONANZA: 41,
  WITCHS_CAULDRON: 5,
  PANDA_PUNCH: 7,
  COSMIC_HERO: 40,
  VIKING_SWORD: 6,
  ROAD_OF_ANUBIS: 8,
  WILD_MAFIA: 9,
  GATE_OF_HEAVEN: 11,
  DRAGON_CURSE: 10,
  DESTROY_MONSTERS: 25,
  AZTEC_PROTECTORS: 26,
  PURPLE_CAVE: 27,
  PUNCH_OF_HEROES: 999, // Not listed in provided game IDs
  SPACE_WARS: 28,
  PINEAPPLE_PARADISE: 12,
  GHOST_GUEST: 999, // Not listed in provided game IDs
  LOPEN_SECRET: 999, // Not listed in provided game IDs
  POWER_SHIELD: 37,
  GATES_OF_TITAN: 38,
  CYBER_BOX: 39,
  DIAMOND_GUN: 17,
  ZODIAC_RUSH: 18, // Not listed in provided game IDs
  JELLY_BOOM: 19,
  SWEET_RUSH: 20,
  MONEY_RATE: 999, // Not listed in provided game IDs
  UPGRADE_2199: 999, // Not listed in provided game IDs
  THE_NORTH_FISHER: 999, // Not listed in provided game IDs
  THE_MINER: 999, // Not listed in provided game IDs
  LUCKY_FARMER: 999, // Not listed in provided game IDs
  THE_HUNTER: 999, // Not listed in provided game IDs
  DIZZY_ZOMBIES: 999, // Not listed in provided game IDs
  CAT_HOUSE: 999, // Not listed in provided game IDs
  EGYPT_RISING: 999, // Not listed in provided game IDs
  FIESTA_PARTY: 999, // Not listed in provided game IDs
  KINGDOM_FIRE: 999, // Not listed in provided game IDs
  SHINING_RING_RISING: 999, // Not listed in provided game IDs
  OLYMPUS_RISING: 999, // Not listed in provided game IDs
  OTTOMAN_LEGENDS: 999, // Not listed in provided game IDs
  WAR_GODS: 999, // Not listed in provided game IDs
  DRAGONS_VS_GUARDIAN: 999, // Not listed in provided game IDs
  STREET_BATTLE: 999, // Not listed in provided game IDs
  LOST_ATLANTIS: 999, // Not listed in provided game IDs
  LAST_SAMURAI: 999, // Not listed in provided game IDs
  ZEROTH: 999, // Not listed in provided game IDs
  // magnum games
  VAMPIRES_LAIR: 1,
  GLADIATOR_COLESSIUM: 2,
  SPLENDID_SULEYMAN: 3,
  NORDIC_RAIDERS: 4,
  JEWEL_OF_WIZARD: 13,
  COSMIC_CRAZIES: 14,
  JELLY_BLISS: 15,
  DRUNKIE_MONKEY: 16,
  CAKE_MASTER: 21,
  WONDERLAND_GROVE: 22,
  SIRENS_BEAUTY: 23,
  AMAZON_SISTERS: 24,
  SEEK_AND_CATCH: 33,
  FERAL_QUEST: 34,
  BANDIT_HUNTER: 35,
  GOLDEN_QUARRY: 36,
  TOSUNCUKS_FARM: 29,
  DYNO_DYNASTY: 30,
  SHADOW_OF_SABBAH: 31,
  SOLAR_SPINS: 32,
  NINJA_PARADISE: 999, // Not listed in provided game IDs
  WANTED_COWBOY: 999, // Not listed in provided game IDs
  WANTED_DEAD_OR_NINJA: 999, // Not listed in provided game IDs
  GATES_OF_NINJA: 999, // Not listed in provided game IDs
  DEDE_1000X: 999, // Not listed in provided game IDs

  // fast game ID
  PLINKO: 51,
  ROULETTE: 63,
  MINE: 52,
  BLACKJACK: 55
}

/* ==========================================================================
  Routes' game Ids
========================================================================== */
export const ROUTE_GAME_NAME_ID = {
  // crash-id
  [ROUTE_PATHS.aztecManGame]: DEFAULT_GAME_ID.AZTECMAN,
  [ROUTE_PATHS.followTheArrowGame]: DEFAULT_GAME_ID.FOLLOW_THE_ARROW,
  [ROUTE_PATHS.galaxyGrabGame]: DEFAULT_GAME_ID.GALAXY_GRAB,
  [ROUTE_PATHS.powerOfThorGame]: DEFAULT_GAME_ID.POWER_OF_THOR,
  [ROUTE_PATHS.happyBirdGame]: DEFAULT_GAME_ID.HAPPY_BIRD,

  // - slot-id first-20
  [ROUTE_PATHS.witchcauldronSlotGame]: DEFAULT_GAME_ID.WITCHS_CAULDRON,
  [ROUTE_PATHS.PandaPunchSlotGame]: DEFAULT_GAME_ID.PANDA_PUNCH,
  [ROUTE_PATHS.vikingSwordSlotGame]: DEFAULT_GAME_ID.VIKING_SWORD,
  [ROUTE_PATHS.roadOfAnubisSlotGame]: DEFAULT_GAME_ID.ROAD_OF_ANUBIS,
  [ROUTE_PATHS.wildMafiaSlotGame]: DEFAULT_GAME_ID.WILD_MAFIA,
  [ROUTE_PATHS.mayaBonanza]: DEFAULT_GAME_ID.MAYA_BONANZA,
  [ROUTE_PATHS.cosmicHeroes]: DEFAULT_GAME_ID.COSMIC_HERO,
  [ROUTE_PATHS.egyptRush]: DEFAULT_GAME_ID.EGYPT_RUSH,
  [ROUTE_PATHS.dragonCurse]: DEFAULT_GAME_ID.DRAGON_CURSE,
  [ROUTE_PATHS.cyberBox]: DEFAULT_GAME_ID.CYBER_BOX,
  [ROUTE_PATHS.powerShield]: DEFAULT_GAME_ID.POWER_SHIELD,
  [ROUTE_PATHS.gatesOfTitan]: DEFAULT_GAME_ID.GATES_OF_TITAN,
  [ROUTE_PATHS.gateOfHeaven]: DEFAULT_GAME_ID.GATE_OF_HEAVEN,
  [ROUTE_PATHS.purpleCave]: DEFAULT_GAME_ID.PURPLE_CAVE,
  [ROUTE_PATHS.spaceWars]: DEFAULT_GAME_ID.SPACE_WARS,
  [ROUTE_PATHS.ghostGuest]: DEFAULT_GAME_ID.GHOST_GUEST,
  [ROUTE_PATHS.destroyMonster]: DEFAULT_GAME_ID.DESTROY_MONSTERS,
  [ROUTE_PATHS.aztecProtector]: DEFAULT_GAME_ID.AZTEC_PROTECTORS,
  [ROUTE_PATHS.lopenSecret]: DEFAULT_GAME_ID.LOPEN_SECRET,
  [ROUTE_PATHS.punchOfHeroes]: DEFAULT_GAME_ID.PUNCH_OF_HEROES,
  [ROUTE_PATHS.pineappleParadise]: DEFAULT_GAME_ID.PINEAPPLE_PARADISE,
  // - slot-id second-20
  [ROUTE_PATHS.diamondGun]: DEFAULT_GAME_ID.DIAMOND_GUN,
  [ROUTE_PATHS.zodiacRush]: DEFAULT_GAME_ID.ZODIAC_RUSH,
  [ROUTE_PATHS.sweetRush]: DEFAULT_GAME_ID.SWEET_RUSH,
  [ROUTE_PATHS.jellyBoom]: DEFAULT_GAME_ID.JELLY_BOOM,
  [ROUTE_PATHS.moneyRate]: DEFAULT_GAME_ID.MONEY_RATE,
  [ROUTE_PATHS.upgrade2199]: DEFAULT_GAME_ID.UPGRADE_2199,
  [ROUTE_PATHS.theNorthFisher]: DEFAULT_GAME_ID.THE_NORTH_FISHER,
  [ROUTE_PATHS.theMiner]: DEFAULT_GAME_ID.THE_MINER,
  [ROUTE_PATHS.luckyFarmer]: DEFAULT_GAME_ID.LUCKY_FARMER,
  [ROUTE_PATHS.theHunter]: DEFAULT_GAME_ID.THE_HUNTER,
  [ROUTE_PATHS.dizzyZombies]: DEFAULT_GAME_ID.DIZZY_ZOMBIES,
  [ROUTE_PATHS.catHouse]: DEFAULT_GAME_ID.CAT_HOUSE,
  [ROUTE_PATHS.egyptRising]: DEFAULT_GAME_ID.EGYPT_RISING,
  [ROUTE_PATHS.fiestaParty]: DEFAULT_GAME_ID.FIESTA_PARTY,
  [ROUTE_PATHS.kingdomFire]: DEFAULT_GAME_ID.KINGDOM_FIRE,
  [ROUTE_PATHS.shiningRingRising]: DEFAULT_GAME_ID.SHINING_RING_RISING,
  [ROUTE_PATHS.olympusRising]: DEFAULT_GAME_ID.OLYMPUS_RISING,
  [ROUTE_PATHS.ottomanLegends]: DEFAULT_GAME_ID.OTTOMAN_LEGENDS,
  [ROUTE_PATHS.warGods]: DEFAULT_GAME_ID.WAR_GODS,
  [ROUTE_PATHS.dragonsVsGuardian]: DEFAULT_GAME_ID.DRAGONS_VS_GUARDIAN,
  [ROUTE_PATHS.streetBattle]: DEFAULT_GAME_ID.STREET_BATTLE,
  [ROUTE_PATHS.lostAtlantis]: DEFAULT_GAME_ID.LOST_ATLANTIS,
  [ROUTE_PATHS.lastSamurai]: DEFAULT_GAME_ID.LAST_SAMURAI,
  [ROUTE_PATHS.zeroth]: DEFAULT_GAME_ID.ZEROTH,
  [ROUTE_PATHS.ninjaParadise]: DEFAULT_GAME_ID.NINJA_PARADISE,
  [ROUTE_PATHS.wantedCowboy]: DEFAULT_GAME_ID.WANTED_COWBOY,
  [ROUTE_PATHS.wantedDeadOrNinja]: DEFAULT_GAME_ID.WANTED_DEAD_OR_NINJA,
  [ROUTE_PATHS.gatesOfNinja]: DEFAULT_GAME_ID.GATES_OF_NINJA,
  [ROUTE_PATHS.dede1000x]: DEFAULT_GAME_ID.DEDE_1000X,
  // magnum games
  [ROUTE_PATHS.vampiresLair]: DEFAULT_GAME_ID.VAMPIRES_LAIR,
  [ROUTE_PATHS.gladiatorColessium]: DEFAULT_GAME_ID.GLADIATOR_COLESSIUM,
  [ROUTE_PATHS.splendidSuleyman]: DEFAULT_GAME_ID.SPLENDID_SULEYMAN,
  [ROUTE_PATHS.nordicRaiders]: DEFAULT_GAME_ID.NORDIC_RAIDERS,
  [ROUTE_PATHS.jewelOfWizard]: DEFAULT_GAME_ID.JEWEL_OF_WIZARD,
  [ROUTE_PATHS.cosmicCrazies]: DEFAULT_GAME_ID.COSMIC_CRAZIES,
  [ROUTE_PATHS.jellyBliss]: DEFAULT_GAME_ID.JELLY_BLISS,
  [ROUTE_PATHS.drunkieMonkey]: DEFAULT_GAME_ID.DRUNKIE_MONKEY,
  [ROUTE_PATHS.cakeMaster]: DEFAULT_GAME_ID.CAKE_MASTER,
  [ROUTE_PATHS.wonderlandGrove]: DEFAULT_GAME_ID.WONDERLAND_GROVE,
  [ROUTE_PATHS.sirensBeauty]: DEFAULT_GAME_ID.SIRENS_BEAUTY,
  [ROUTE_PATHS.amazonSisters]: DEFAULT_GAME_ID.AMAZON_SISTERS,
  [ROUTE_PATHS.seekAndCatch]: DEFAULT_GAME_ID.SEEK_AND_CATCH,
  [ROUTE_PATHS.feralQuest]: DEFAULT_GAME_ID.FERAL_QUEST,
  [ROUTE_PATHS.banditHunter]: DEFAULT_GAME_ID.BANDIT_HUNTER,
  [ROUTE_PATHS.goldenQuarry]: DEFAULT_GAME_ID.GOLDEN_QUARRY,
  [ROUTE_PATHS.tosuncuksFarm]: DEFAULT_GAME_ID.TOSUNCUKS_FARM,
  [ROUTE_PATHS.dynoDynasty]: DEFAULT_GAME_ID.DYNO_DYNASTY,
  [ROUTE_PATHS.shadowOfSabbah]: DEFAULT_GAME_ID.SHADOW_OF_SABBAH,
  [ROUTE_PATHS.solarSpins]: DEFAULT_GAME_ID.SOLAR_SPINS,

  // - fast-game-id
  [ROUTE_PATHS.plinkoGame]: DEFAULT_GAME_ID.PLINKO,
  [ROUTE_PATHS.rouletteGame]: DEFAULT_GAME_ID.ROULETTE,
  [ROUTE_PATHS.mineGame]: DEFAULT_GAME_ID.MINE,
  [ROUTE_PATHS.blackjackGame]: DEFAULT_GAME_ID.BLACKJACK
}

/* ==========================================================================
  Extra Constants Variables
========================================================================== */
export const PAGINATION_LIMIT = 20
export const MIN_WITHDRAW_AMOUNT = 0.003
export const WITHDRAW_FEES = 0.000006
export const DEFAULT_PAGE_CALLS = 20
export const DEFAULT_TOP_BET_TYPE_LIMIT = 20
export const DEFAULT_MY_BETS_LIMIT = 20
export const DEFAULT_PRECISION_MONEY = 2
export const DEFAULT_AUTO_BET_COUNTER = 3
export const DEFAULT_BET_AMOUNT_SC = 1
export const DEFAULT_BET_AMOUNT_GC = 2500
export const TAB_SELECTION = Object.freeze({
  placed: Symbol('placed'),
  previous: Symbol('previous')
})
export const MIN_PAYOUT = {
  CRASH: 1.1
}

export const APPEND_TYPES = {
  ROUND_STOPPED: 'ROUND_STOPPED',
  ESCAPE: 'ESCAPE'
}

export const GAME_NAMES = {
  AZTECMAN: 'AZTECMAN',
  GALAXY_GRAB: 'GALAXY_GRAB',
  FOLLOW_THE_ARROW: 'FOLLOW_THE_ARROW',
  POWER_OF_THOR: 'POWER_OF_THOR',
  HAPPY_BIRD: 'HAPPY_BIRD'
}

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

export const COIN_CURRENCY_ID = {
  GC: '1',
  SC: '2'
}

export const COIN_CURRENCY_CODES = {
  GC: 'GC',
  SC: 'SC'
}

export const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$'
}

/* ==========================================================================
  Wallet emit types
========================================================================== */
export const WALLET_EMIT_TYPES = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const PROVABLE_FAIR_TEXT = '"Provably fair" is a term that refers to a system or algorithm used in online gambling or gaming that can be mathematically verified to ensure that the results are fair and not manipulated in any way. It is a way for players to know that the game or gambling platform they are using is legitimate and not rigged against them.'

export const TOP_BET_TYPE = {
  BIGGEST_WIN: 'BIGGEST_WIN',
  HUGE_WIN: 'HUGE_WIN',
  MULTIPLIER: 'MULTIPLIER',
  GOLD_COINS: 'GC',
  SWEEPSTAKES_COINS: 'SC'
}

export const CRASH_BET_LISTING_TYPE_TABS = {
  ALL_BETS: 'ALL_BETS',
  MY_BETS: 'MY_BETS',
  TOP_BETS: 'TOP_BETS'
}

/* ==========================================================================
  LocalStorage / Session Storage / Cookies data constant
  ========================================================================== */
export const PANEL_UNIQUE_CONSTANT = Object.freeze({
  TOKEN: 'slot_game_user_panel_authtoken',
  LANGUAGE: 'slot_game_user_panel_language',
  USER_INFO: 'slot_game_user_panel_user_info',
  USER_BALANCE: 'slot_game_user_panel_user_balance',
  USER_CURRENCY: 'slot_game_user_panel_user_currency'
})

/* ==========================================================================
  Toaster color constants
  ========================================================================== */

export const CRASH_GAMES_TOAST_COLOR = {
  [ROUTE_PATHS.aztecManGame]: { bg: 'linear-gradient(90deg, var(--exaAPrimary) 2.71%, var(--exaAPrimaryHover) 100%)', fill: 'var(--exaAPrimary)' },
  [ROUTE_PATHS.galaxyGrabGame]: { bg: 'linear-gradient(180deg, var(--exaBPrimaryHover) 0%, var(--exaBPrimary) 100%)', fill: 'var(--exaBPrimary)' },
  [ROUTE_PATHS.followTheArrowGame]: { bg: 'linear-gradient(180deg, var(--exaCPrimaryHover) 0%, var(--exaCPrimary) 100%)', fill: 'var(--exaCPrimary)' },
  [ROUTE_PATHS.happyBirdGame]: { bg: 'linear-gradient(180deg, var(--exaDPrimaryHover) 0%, var(--exaDPrimary) 100%)', fill: 'var(--exaDPrimary)' },
  [ROUTE_PATHS.powerOfThorGame]: { bg: 'linear-gradient(90deg, var(--exaEPrimary) 2.71%, var(--exaEPrimaryHover) 100%)', fill: 'var(--exaEPrimary)' },
  ERROR: { bg: 'linear-gradient(90deg, var(--defaultToast) 2.71%, var(--defaultToastHover) 100%)', fill: 'var(--defaultToast)' },
  INFO: { bg: 'linear-gradient(90deg, #3498db 2.71%,#549fd2 100%)', fill: '#3498db' },
  DEFAULT: { bg: 'linear-gradient(90deg, #0ba51a  2.71%, #46a650  100%)', fill: '#0ba51a ' }
}
